import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';
import * as style from './BuilderInfoItem.css';
import { BasicInfoLink } from '../BasicInfoLink';

export interface IBuilderInfoItemProps {
  logoUrl: string;
  linkUrl: string;
  value: string;
  onClick(): void;
}

export const BuilderInfoItem: React.FC<IBuilderInfoItemProps> = props => {
  const { logoUrl, linkUrl, value, onClick } = props;

  return (
    <div className={style['container']}>
      <div className={style['logo']} style={{ backgroundImage: `url(${logoUrl})` }} />
      <div>
        <ArticleParagraph2 color="text-secondary-default">Застройщик</ArticleParagraph2>
        <BasicInfoLink text={value} linkUrl={linkUrl} onClick={onClick} withIcon={true} fontSize="S" />
      </div>
    </div>
  );
};
